{
  "familyId": "REK-HANDIG-DEEL",
  "questions": [
    {
      "id": "REK-HANDIG-DEEL-001",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 360 ÷ 15. Welke manier is het handigst?",
      "options": [
        "Factoren: 360 ÷ 15 = 360 ÷ 3 ÷ 5 = 120 ÷ 5 = 24",
        "Staartdeling: 36 ÷ 15 = 2 rest 6, dan 60 ÷ 15 = 4 → 24",
        "Herhaald aftrekken: 360 − 15 − 15 − 15 ... (24 keer)",
        "Halveren: 360 ÷ 2 = 180, dan 180 ÷ 7,5 = 24"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "splitDiagram",
          "showWhen": "wrong",
          "data": {
            "original": 15,
            "parts": [
              { "value": 3, "label": "÷3" },
              { "value": 5, "label": "÷5" }
            ],
            "operation": "multiply",
            "operand": 360,
            "result": 24,
            "label": "15 = 3 × 5 → splits de deler"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen via factoren",
            "content": "15 = 3 × 5. Dus 360 ÷ 15 = 360 ÷ 3 ÷ 5. Eerst: 360 ÷ 3 = 120. Dan: 120 ÷ 5 = 24. Door de deler in factoren te splitsen, maak je twee makkelijke delingen!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_factoren",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "360 ÷ 15 = 24. Handig: splits 15 in factoren: 15 = 3 × 5. Eerst 360 ÷ 3 = 120, dan 120 ÷ 5 = 24. Door de deler in factoren te splitsen, maak je twee makkelijke delingen in plaats van één moeilijke. Tegenproef: 24 × 15 = 360 ✓",
        "solutionSteps": [
          "Herken factoren: 15 = 3 × 5",
          "360 ÷ 3 = 120",
          "120 ÷ 5 = 24"
        ],
        "distractorExplanations": {
          "0": "Goed! 360 ÷ 3 = 120, dan 120 ÷ 5 = 24. Factoren splitsen is hier de handigste manier.",
          "1": "Staartdeling werkt, maar is meer werk. Met factoren (÷3, dan ÷5) heb je twee eenvoudige stappen.",
          "2": "Herhaald aftrekken is de langzaamste manier — je moet 24 keer aftrekken! Factoren splitsen is veel sneller.",
          "3": "Halveren en dan door 7,5 delen maakt het juist moeilijker. 7,5 is geen handig getal. Factoren (3 × 5) zijn veel makkelijker."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.niet-handige-strategie", "label": "Kiest staartdeling i.p.v. handig", "optionIndex": 1 },
          { "id": "rek.niet-handige-strategie", "label": "Kiest herhaald aftrekken", "optionIndex": 2 },
          { "id": "rek.niet-handige-strategie", "label": "Kiest halveren bij oneven deler", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-HANDIG-DEEL-002",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "fill_in",
      "question": "Reken handig uit: 480 ÷ 12",
      "options": [],
      "correctAnswer": "40",
      "data": {
        "acceptedAnswers": ["40"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "strategySteps",
          "showWhen": "wrong",
          "data": {
            "title": "Halveren — beide getallen",
            "steps": [
              { "label": "480 ÷ 12" },
              { "label": "halveer: 240 ÷ 6", "highlight": true },
              { "label": "240 ÷ 6 = 40" }
            ],
            "label": "Halveer beide getallen tot je makkelijk kunt delen"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Halveren als handige aanpak",
            "content": "480 ÷ 12: halveer beide getallen! 480 ÷ 2 = 240, en 12 ÷ 2 = 6. Nu: 240 ÷ 6 = 40. Of via factoren: 12 = 4 × 3, dus 480 ÷ 4 = 120, dan 120 ÷ 3 = 40.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_halveren",
      "variantIndex": 2,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "480 ÷ 12 = 40. Handig: halveer beide getallen: 480 ÷ 2 = 240, 12 ÷ 2 = 6. Nu: 240 ÷ 6 = 40. Of via factoren: 12 = 4 × 3, dus 480 ÷ 4 = 120, dan 120 ÷ 3 = 40. Tegenproef: 40 × 12 = 480 ✓",
        "solutionSteps": [
          "Strategie: halveer beide getallen",
          "480 ÷ 2 = 240, 12 ÷ 2 = 6",
          "240 ÷ 6 = 40"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-verkeerde-gegevens", "label": "Verwart deler (deelt door 10 i.p.v. 12)" },
          { "id": "rek.rekenfout", "label": "Deelfout bij 480 ÷ 12" },
          { "id": "rek.strategie-verkeerde-correctie", "label": "Halveert te vaak of te weinig" }
        ]
      }
    },
    {
      "id": "REK-HANDIG-DEEL-003",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "strategy_solver",
      "question": "Reken handig uit: 750 ÷ 25. Kies eerst een handige manier en reken dan uit.",
      "options": [],
      "correctAnswer": "30",
      "data": {
        "strategySolver": {
          "expression": "750 ÷ 25",
          "strategies": [
            { "id": "maal_vier_truc", "label": "× 4 ÷ 100", "icon": "swap", "hint": "÷ 25 = × 4 ÷ 100. Dus 750 × 4 = 3.000, dan ÷ 100 = 30", "tier": "optimal" },
            { "id": "factoren", "label": "Splits in factoren", "icon": "split", "hint": "25 = 5 × 5. Dus 750 ÷ 5 = 150, dan 150 ÷ 5 = 30", "tier": "optimal" },
            { "id": "schatten", "label": "Schatten & bijstellen", "icon": "lightbulb", "hint": "30 × 25 = 750, dus precies 30", "tier": "ok" },
            { "id": "cijferend", "label": "Cijferend (staartdeling)", "icon": "calculator", "hint": "Onder elkaar — werkt, maar omslachtig voor deze som", "tier": "suboptimal" }
          ],
          "acceptedAnswers": ["30"]
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen door 25 = × 4 ÷ 100",
            "content": "Delen door 25 is hetzelfde als vermenigvuldigen met 4 en dan delen door 100. 750 × 4 = 3.000, dan 3.000 ÷ 100 = 30. Of: 750 ÷ 25 = 750 ÷ 5 ÷ 5 = 150 ÷ 5 = 30.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_25_truc",
      "variantIndex": 3,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "750 ÷ 25 = 30. Handige truc: ÷ 25 = × 4 ÷ 100. Dus 750 × 4 = 3.000, dan 3.000 ÷ 100 = 30. Of via factoren: 25 = 5 × 5, dus 750 ÷ 5 = 150, dan 150 ÷ 5 = 30. Tegenproef: 30 × 25 = 750 ✓",
        "solutionSteps": [
          "Strategie: ÷ 25 = × 4 ÷ 100",
          "750 × 4 = 3.000",
          "3.000 ÷ 100 = 30"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.niet-handige-strategie", "label": "Kiest cijferende staartdeling i.p.v. handige strategie" },
          { "id": "rek.rekenfout", "label": "Rekenfout bij × 4 of ÷ 100" }
        ]
      }
    },
    {
      "id": "REK-HANDIG-DEEL-004",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "multiple_choice",
      "question": "Een sportvereniging verdeelt €1.800 gelijk over 12 teams. Hoeveel krijgt elk team? Reken handig.",
      "options": ["€150", "€160", "€145", "€180"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "splitDiagram",
          "showWhen": "wrong",
          "data": {
            "original": 12,
            "parts": [
              { "value": 4, "label": "÷4" },
              { "value": 3, "label": "÷3" }
            ],
            "operation": "multiply",
            "operand": 1800,
            "result": 150,
            "label": "1.800 ÷ 12 → splits 12 = 4 × 3"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Handig delen in context",
            "content": "1.800 ÷ 12: splits 12 = 4 × 3. Eerst 1.800 ÷ 4 = 450. Dan 450 ÷ 3 = 150. Of halveer: 1.800 ÷ 2 = 900, 12 ÷ 2 = 6. Nu: 900 ÷ 6 = 150.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_context",
      "variantIndex": 4,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "€1.800 ÷ 12 = €150. Handig: splits 12 in factoren: 12 = 4 × 3. Eerst 1.800 ÷ 4 = 450, dan 450 ÷ 3 = 150. Elk team krijgt €150. Tegenproef: 150 × 12 = 1.800 ✓",
        "solutionSteps": [
          "Herken: €1.800 ÷ 12 teams",
          "Factoren: 12 = 4 × 3",
          "1.800 ÷ 4 = 450",
          "450 ÷ 3 = 150"
        ],
        "distractorExplanations": {
          "0": "Goed! €1.800 ÷ 12 = €150 per team. Dat klopt helemaal.",
          "1": "Je dacht waarschijnlijk 1.800 ÷ 12 ≈ 160. Maar 160 × 12 = 1.920 ≠ 1.800. Controleer: 150 × 12 = 1.800. ✓",
          "2": "Je dacht waarschijnlijk 1.800 ÷ 12 ≈ 145. Maar 145 × 12 = 1.740 ≠ 1.800. Controleer: 150 × 12 = 1.800. ✓",
          "3": "Je deelde waarschijnlijk door 10 in plaats van 12: 1.800 ÷ 10 = 180. Maar er zijn 12 teams, niet 10. 1.800 ÷ 12 = 150."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.rekenfout", "label": "Deelfout: 1800÷12≈160", "optionIndex": 1 },
          { "id": "rek.rekenfout", "label": "Deelfout: 1800÷12≈145", "optionIndex": 2 },
          { "id": "rek.context-verkeerde-gegevens", "label": "Deelt door 10 i.p.v. 12", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-HANDIG-DEEL-005",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 2.400 ÷ 16. Welke manier is het handigst?",
      "options": [
        "Herhaald halveren: 2.400 ÷ 2 = 1.200, ÷ 2 = 600, ÷ 2 = 300, ÷ 2 = 150",
        "Factoren: 2.400 ÷ 4 = 600, dan 600 ÷ 4 = 150",
        "Staartdeling: 24 ÷ 16 = 1 rest 8, dan 80 ÷ 16 = 5 ... → 150",
        "Compenseren: 2.400 ÷ 20 = 120, dan bijstellen → 150"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Herhaald halveren bij machten van 2",
            "content": "16 = 2 × 2 × 2 × 2. Dus ÷ 16 = vier keer halveren! 2.400 → 1.200 → 600 → 300 → 150. Dit is de snelste strategie als de deler een macht van 2 is.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_herhaald_halveren",
      "variantIndex": 5,
      "citoDifficulty": 0.54,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "2.400 ÷ 16 = 150. Herhaald halveren is hier het handigst: 16 = 2⁴, dus halveer vier keer. 2.400 → 1.200 → 600 → 300 → 150. Dit werkt altijd als de deler een macht van 2 is (2, 4, 8, 16, 32...). Tegenproef: 150 × 16 = 2.400 ✓",
        "solutionSteps": [
          "Herken: 16 = 2 × 2 × 2 × 2",
          "2.400 ÷ 2 = 1.200",
          "1.200 ÷ 2 = 600",
          "600 ÷ 2 = 300",
          "300 ÷ 2 = 150"
        ],
        "distractorExplanations": {
          "0": "Goed! Vier keer halveren: 2.400 → 1.200 → 600 → 300 → 150. Slim!",
          "1": "Factoren (÷ 4 ÷ 4) werkt ook en geeft hetzelfde antwoord. Maar herhaald halveren is nóg eenvoudiger — je hoeft alleen maar te halveren.",
          "2": "Staartdeling werkt, maar is veel meer werk. Herhaald halveren is sneller en minder foutgevoelig.",
          "3": "Compenseren (÷ 20 = 120, dan bijstellen) is hier lastig — je moet uitrekenen hoeveel je moet bijstellen. Herhaald halveren is directer."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.niet-handige-strategie", "label": "Kiest factoren i.p.v. halveren", "optionIndex": 1 },
          { "id": "rek.niet-handige-strategie", "label": "Kiest staartdeling i.p.v. handig", "optionIndex": 2 },
          { "id": "rek.niet-handige-strategie", "label": "Kiest compenseren bij deling", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-HANDIG-DEEL-006",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "number_sequence",
      "question": "Vul de reeks aan. We delen steeds door 2 (halveren).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sequence": [3200, 1600, 800, null, 200, null],
        "missingIndices": [3, 5],
        "correctValues": [400, 100],
        "acceptedAnswers": [["400", "100"]]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Herhaald halveren",
            "content": "Als je deelt door 2, neem je de helft. 800 ÷ 2 = 400. En 200 ÷ 2 = 100.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_halveren_reeks",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.rekenfout", "label": "Halveringsfout: 800 ÷ 2 niet correct" },
          { "id": "rek.niet-handige-strategie", "label": "Past halveerregel niet consistent toe op reeks" }
        ]
      },
      "feedback": {
        "explanationText": "De regel in deze reeks is: deel door 2 (halveren). De helft van 800 is 400. De helft van 200 is 100. Controleer: 400 × 2 = 800 en 100 × 2 = 200 ✓",
        "solutionSteps": [
          "Stap 1: 800 ÷ 2 = 400",
          "Stap 2: 200 ÷ 2 = 100"
        ]
      }
    },
    {
      "id": "REK-HANDIG-DEEL-007",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "multiple_choice",
      "question": "Een school koopt 1.200 pennen in dozen van 25 stuks. Hoeveel dozen zijn dat? Reken handig.",
      "options": ["48", "40", "50", "45"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen door 25",
            "content": "Delen door 25 is hetzelfde als vermenigvuldigen met 4 en delen door 100. 1.200 × 4 = 4.800. En 4.800 ÷ 100 = 48.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_25_context",
      "variantIndex": 7,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "1.200 ÷ 25 = 48. Handige truc: ÷ 25 = × 4 ÷ 100. Dus 1.200 × 4 = 4.800, dan 4.800 ÷ 100 = 48 dozen. Tegenproef: 48 × 25 = 1.200 ✓",
        "solutionSteps": [
          "Herken: 1.200 ÷ 25",
          "Truc: × 4 ÷ 100",
          "1.200 × 4 = 4.800",
          "4.800 ÷ 100 = 48"
        ],
        "distractorExplanations": {
          "0": "Goed! 1.200 ÷ 25 = 48 dozen. Je hebt het totaal aantal pennen correct verdeeld over de dozen.",
          "1": "Je dacht waarschijnlijk 1.000 ÷ 25 = 40. Maar het is 1.200, dus er komen nog 8 dozen bij (200 ÷ 25 = 8).",
          "2": "Je hebt waarschijnlijk geschat. 50 × 25 = 1.250. Het is iets minder: 48.",
          "3": "Je hebt waarschijnlijk een rekenfout gemaakt. 45 × 25 = 1.125."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.rekenfout", "label": "Deelt 1000 i.p.v. 1200", "optionIndex": 1 },
          { "id": "rek.schattingsfout", "label": "Schatting te hoog", "optionIndex": 2 },
          { "id": "rek.rekenfout", "label": "Rekenfout: 45×25=1125 ≠ 1200", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-HANDIG-DEEL-008",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "strategy_solver",
      "question": "Reken handig uit: 540 ÷ 18. Kies eerst een handige manier en reken dan uit.",
      "options": [],
      "correctAnswer": "30",
      "data": {
        "strategySolver": {
          "expression": "540 ÷ 18",
          "strategies": [
            { "id": "factoren_9x2", "label": "Splits 18 = 9 × 2", "icon": "split", "hint": "540 ÷ 9 = 60, dan 60 ÷ 2 = 30", "tier": "optimal" },
            { "id": "halveer_beide", "label": "Halveer beide", "icon": "swap", "hint": "540 ÷ 2 = 270 en 18 ÷ 2 = 9. Dan 270 ÷ 9 = 30", "tier": "optimal" },
            { "id": "factoren_2x3x3", "label": "Splits 18 = 2 × 3 × 3", "icon": "puzzle", "hint": "Drie deelstappen: ÷ 2, ÷ 3, ÷ 3", "tier": "ok" },
            { "id": "cijferend", "label": "Cijferend (staartdeling)", "icon": "calculator", "hint": "Onder elkaar — werkt, maar duurt langer", "tier": "suboptimal" }
          ],
          "acceptedAnswers": ["30"]
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Splitsen in factoren",
            "content": "18 = 9 × 2. Dus 540 ÷ 18 = 540 ÷ 9 ÷ 2. Eerst 540 ÷ 9 = 60. Dan 60 ÷ 2 = 30.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_factoren_18",
      "variantIndex": 8,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "540 ÷ 18 = 30. Handig: splits 18 in factoren (9 × 2). Eerst 540 ÷ 9 = 60. Dan 60 ÷ 2 = 30. Tegenproef: 30 × 18 = 540 ✓",
        "solutionSteps": [
          "Factoren: 18 = 9 × 2",
          "540 ÷ 9 = 60",
          "60 ÷ 2 = 30"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.niet-handige-strategie", "label": "Kiest cijferende staartdeling i.p.v. factoren of halveren" },
          { "id": "rek.rekenfout", "label": "Rekenfout bij ÷ 9 of ÷ 2" }
        ]
      }
    }
  ]
}